module["exports"] = ["vägen", "gatan", "gränden", "gärdet", "allén"];